/* src/app/components/licenses-components/licenses-new-license-creation-card/licenses-new-license-creation-card.component.scss */
.info-card :host ::ng-deep article > header {
  padding-top: 1rem;
}
.info-card .section-heading {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0 0.25rem 0;
  width: 100%;
}
.info-card .active-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
  font-weight: 600;
  margin-top: 0.5rem;
  margin-left: auto;
}
.info-card .active-toggle > input[type=checkbox] {
  width: 1.6rem;
  height: 1.6rem;
}
.info-card footer .form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 0.25rem 0;
}
.info-card footer .basic-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  column-gap: 0.5rem;
}
.info-card footer .assignment-grid {
  grid-template-columns: minmax(0, 0.55fr) minmax(0, 1fr) minmax(0, 0.55fr) minmax(0, 1fr);
  column-gap: 0.5rem;
  align-items: center;
}
.info-card footer .assignment-grid > app-mb-field {
  min-width: 0;
}
.info-card footer .assignment-grid > app-mb-field.toggle-field ::ng-deep > div {
  align-items: center;
  justify-content: center;
}
.info-card footer .assignment-grid > app-mb-field.toggle-field ::ng-deep > div > p {
  margin: 0.5rem 0 0.35rem 0;
  text-align: center;
}
.info-card footer .assignment-grid > app-mb-field.toggle-field ::ng-deep > div > input[type=checkbox] {
  margin: 0.15rem 0 0 0;
  align-self: center;
}
.info-card footer .validity-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 0.5rem;
}
.info-card footer .validity-grid > app-mb-field {
  min-width: 0;
}
.info-card footer .form-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.info-card footer .form-actions > span {
  font-size: 1.2rem;
  color: #5e6e82;
  flex-grow: 1;
  text-align: center;
  margin: 3rem 0 3rem 0;
}
.info-card footer h6 {
  color: red;
  margin: 1rem;
}
.info-card footer > h6 {
  font-size: 1.8;
  padding: 1rem;
  background-color: rgba(255, 0, 0, 0.15);
}
.info-card footer > figure {
  display: flex;
  flex-direction: column;
  height: 400px;
  margin: 1rem 0;
  border: 1px solid #5e6e82;
}
.info-card footer > figure > div {
  width: 100%;
  height: 100%;
}
.info-card footer > ul {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #5e6e82;
}
@media (max-width: 900px) {
  .info-card footer .form-grid {
    grid-template-columns: 1fr;
  }
  .info-card footer .form-actions {
    justify-content: stretch;
  }
  .info-card footer .form-actions > app-mb-button {
    width: 100%;
  }
}
/*# sourceMappingURL=licenses-new-license-creation-card.component.css.map */
